import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Onboarding } from '../../../models/onboarding';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'alg-list-progress',
  templateUrl: './alg-list-progress.component.html',
  styleUrls: ['./alg-list-progress.component.scss'],
})
export class AlgListProgressComponent implements OnInit {
  @Input() allSteps: any;
  @Input() isPlacet: boolean;
  @Output() sendTypeStatusValue: EventEmitter<string> = new EventEmitter();

  constructor(private api: ApiService) {}

  ngOnInit() {}

  clickOnStep(type) {
    return this.sendTypeStatusValue.emit(
      this.allSteps.filter((e) => e.stepNumber === type)[0]
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/atoms/alg-list-progress/alg-list-progress.component.ts